interface SubmitButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export function SubmitButton({
  label,
  onClick,
  disabled = false,
  loading = false,
}: SubmitButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      className={`min-h-[44px] w-full max-w-md px-6 py-3 rounded-full border border-[#f97216] font-['DM_Sans',sans-serif] text-2xl text-center transition-colors disabled:cursor-not-allowed ${disabled || loading ? 'text-[#757575]' : 'text-white'}`}
      style={
        disabled || loading
          ? undefined
          : {
              backgroundImage: 'var(--brand-gradient-60)',
              boxShadow: 'var(--orange-glow)',
            }
      }
    >
      {loading ? 'Working...' : label}
    </button>
  );
}
